/**
 * Returns an HTTP method wrapper
 * TODO: Add abort feature (https://developer.mozilla.org/en-US/docs/Web/API/AbortController)
 * TODO: Add streams (https://jakearchibald.com/2016/streams-ftw/)
 * TODO: Add Progress (https://danlevy.net/you-may-not-need-axios/)
 * @param {string} [method] HTTP method
 * @returns {function}
 */
function wrapper(method, defaultOpts = {}) {
  /**
   * A convenient HTTP method wrapper
   * @param {string} url
   * @param {object} [options={}] see https://javascript.info/fetch-api for full list of options
   * @return {promise} Resulting fetch promise which resolves to the text or json response.
   */
  return (url, options = defaultOpts) => {
    options.method = options.method || method
    options.headers = options.headers || {}
    const { query, json, data, form, body } = options

    if (query) {
      url += "?" + new URLSearchParams(query).toString()
    }

    if (["post", "put", "patch"].includes(options.method) && !body) {
      if (json) {
        options.headers["content-type"] = "application/json"
        options.body = JSON.stringify(json)
      } else if (data) {
        options.body = new URLSearchParams(data)
      } else if (form) {
        options.body = new FormData(form)
      }
    }

    return fetch(url, options).then(async (res) => {
      const contentType = res.headers.get("content-type")
      const isJson = contentType && contentType.includes("application/json")

      const final = {
        timeout: res.timeout,
        url: res.url,
        status: res.status,
        statusText: res.statusText,
        ok: res.ok,
        // redirected false
        headers: res.headers,
        // text [Function: text]
        // json [Function: json]
        // blob [Function: blob]
        // buffer [Function: buffer]
        data: isJson ? await res.json() : await res.text(),
      }

      return final.ok ? final.data : Promise.reject(final)
    })
  }
}

const defaultOpts = {
  transformRequest: [],
}

const verbs = ["get", "post", "put", "patch", "delete"]

function http(options) {
  options = Object.assign({}, defaultOpts, options)
  options = options.transformRequest.reduce((opts, fn) => fn(opts), options)

  const entries = verbs.map((verb) => {
    return [verb, wrapper(verb, options)]
  })
  return Object.fromEntries(entries)
}

for (const verb of verbs) {
  http[verb] = wrapper(verb)
}

export default http
